import { useEffect, useRef } from 'react';
import DefaultPoster from './assets/transparent.svg?inline';

interface IInlineVideoProps {
  className?: string;
  src: string;
  poster?: string;
}

/**
 * 1. automatic pause & play according to document visibility
 * 2. playing video when user interactive in energy saving mode
 */
export const InlineVideo = (props: IInlineVideoProps) => {
  const { className, src, poster } = props;
  const video = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const $video = video.current;
    if (!$video) {
      return () => void 0;
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        $video.play().catch(() => void 0);
      }
      if (document.visibilityState === 'hidden') {
        $video.pause();
      }
    };

    // 在省电模式下，视频不会自动播放，在用户交互时尝试播放视频
    const clickToPlay = () => {
      if ($video.paused) {
        $video.play().catch(() => void 0);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('click', clickToPlay);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('click', clickToPlay);
    };
  }, []);

  return (
    <video
      className={className}
      ref={video}
      loop
      autoPlay
      muted
      playsInline
      poster={poster || DefaultPoster}
      preload={'auto'}
    >
      <source src={src} />
    </video>
  );
};
